import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when a user clicks the recently deleted upgrade prompt',
  name: 'clicked_recently_deleted_upgrade_prompt',
  params: [],
};

export default META;
